// import gsap from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

gsap.registerPlugin(ScrollTrigger);

let progressEndFlag = false;

window.beBoldSliderInit = function beBoldSliderInit() {
  if (window.innerWidth > 1024) {
    /*let progressEndFlag = false;*/
    const beBoldSec = document.querySelector('.be-bold-sec');

    if (beBoldSec) {
      const beBoldSlides = document.querySelector('.be-bold-sec__slides');
      const slides = gsap.utils.toArray('.be-bold-sec__slide');
      const container = document.querySelector('.cont');

      let totalWidth = 0;
      const positions = [];

      slides.forEach((slide) => {
        positions.push(totalWidth);
        totalWidth += slide.offsetWidth;
      });

      beBoldSlides.style.width = `${totalWidth}px`;

      const containerPaddingLeft = container
        ? parseFloat(getComputedStyle(container).paddingLeft) ||
          container.getBoundingClientRect().left
        : 0;

      const visibleWidth = beBoldSec.offsetWidth - containerPaddingLeft;
      const speedFactor = 1.5;
      const scrollDistance = (totalWidth - visibleWidth) / speedFactor;
      const finalX = -(totalWidth - visibleWidth);

      slides.forEach((slide, index) => {
        const slidePosition = positions[index] - containerPaddingLeft;

        let scale, opacity, x;

        if (slidePosition <= 0) {
          scale = 1;
          opacity = 1;
          x = 0;
        } else {
          const maxDistance = visibleWidth;
          const normalizedDistance = Math.min(slidePosition / maxDistance, 1);

          scale = 1 - normalizedDistance * 0.35;
          opacity = 1 - normalizedDistance * 0.8;
          x = normalizedDistance * 100;
        }

        gsap.set(slide, {
          scale: scale,
          opacity: opacity,
          x: x,
        });
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: beBoldSec,
          pin: true,
          scrub: 1,
          start: 'top top',
          end: () => `+=${scrollDistance}`,
          onUpdate: (self) => {
            const progress = self.progress;

            if (progress >= 0.05) {
              progressEndFlag = true;
            }

            if (progress >= 0.972) {
              for (let i = 0; i < slides.length; i++) {
                if (!slides[i].classList.contains('is-last')) {
                  slides[i].classList.add('is-last-opacity');
                }
              }
            } else {
              for (let i = 0; i < slides.length; i++) {
                if (!slides[i].classList.contains('is-last')) {
                  slides[i].classList.remove('is-last-opacity');
                }
              }
            }

            const currentX = finalX * progress;

            slides.forEach((slide, index) => {
              const slidePosition =
                positions[index] + currentX - containerPaddingLeft;

              let scale, opacity, x;

              if (slidePosition <= 0) {
                scale = 1;
                opacity = 1;
                x = 0;
              } else {
                const maxDistance = visibleWidth;
                const normalizedDistance = Math.min(
                  slidePosition / maxDistance,
                  1
                );

                scale = 1 - normalizedDistance * 0.35;
                opacity = 1 - normalizedDistance * 0.8;
                x = normalizedDistance * 100;
              }

              gsap.set(slide, {
                scale: scale,
                opacity: opacity,
                x: x,
              });
            });
          },
        },
      });

      tl.to(beBoldSlides, {
        x: finalX,
        ease: 'none',
      });
    }
  }

  const beBoldTitle = document.querySelector(
    '.text-sec.be-bold-type .text-sec__title'
  );
  const beBoldText = document.querySelector(
    '.text-sec.be-bold-type .text-sec__text-fixed'
  );
  const beBoldTextNotAnimation = document.querySelector(
    '.text-sec.be-bold-type .text-sec__text:not(.text-sec__text-fixed)'
  );
  const beBoldTextSec = document.querySelector('.text-sec.be-bold-type');
  const beBoldWe = document.querySelector('.be-bold-sec-wr');

  let sharedMinOffset = 265;
  if (window.innerHeight >= 1100) {
    sharedMinOffset = 290;
  } else if (window.innerHeight <= 850) {
    sharedMinOffset = 235;
  } else if (window.innerHeight <= 800) {
    sharedMinOffset = 205;
  } else if (window.innerHeight <= 740) {
    sharedMinOffset = 190;
  }

  // общая переменная для трека
  let sharedTrackHeight = null;

  // --- TITLE ---
  if (beBoldTitle && window.innerWidth > 1024) {
    setTimeout(() => {
      const maxOffset = 450;
      const minOffset = sharedMinOffset;
      const diff = maxOffset - minOffset;

      if (
        !beBoldTitle.parentElement.classList.contains('be-bold-title-wrapper')
      ) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('be-bold-title-wrapper');
        beBoldTitle.parentElement.insertBefore(wrapper, beBoldTitle);
        wrapper.appendChild(beBoldTitle);
      }

      const wrapper = document.querySelector('.be-bold-title-wrapper');

      beBoldTitle.style.transform = `translateY(${diff}px)`;
      beBoldTextNotAnimation.style.marginTop = `${diff * 2}px`;

      if (beBoldWe) {
        sharedTrackHeight =
          beBoldWe.clientHeight +
          beBoldTextSec.clientHeight -
          parseFloat(getComputedStyle(beBoldWe).paddingTop) -
          window.innerHeight -
          beBoldTitle.clientHeight;
      } else {
        sharedTrackHeight =
          beBoldTextSec.clientHeight +
          beBoldTitle.clientHeight / 2 -
          parseFloat(getComputedStyle(beBoldTextNotAnimation).marginTop);
      }

      ScrollTrigger.create({
        trigger: wrapper,
        start: `top top+=${minOffset}`,
        end: `+=${sharedTrackHeight}`, // общий трек
        pin: true,
        pinSpacing: false,
        scrub: true,
        onUpdate: (self) => {
          const progress = self.progress;

          if (progress <= 0.3) {
            const eased = 1 - progress / 0.3;
            const y = diff * eased;
            beBoldTitle.style.transform = `translateY(${y}px)`;
          } else {
            beBoldTitle.style.transform = `translateY(0px)`;
          }
        },
      });

      const pinSpacer = wrapper.closest('.pin-spacer');
      if (pinSpacer) {
        pinSpacer.classList.add('text-sec__be-bold-title');
      }
    }, 1200);
  }

  // --- TEXT ---
  if (beBoldText && window.innerWidth > 1024) {
    setTimeout(function () {
      const minOffset = sharedMinOffset;

      if (
        !beBoldText.parentElement.classList.contains('be-bold-text-wrapper')
      ) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('be-bold-text-wrapper');
        beBoldText.parentElement.insertBefore(wrapper, beBoldText);
        wrapper.appendChild(beBoldText);
      }

      const wrapper = document.querySelector('.be-bold-text-wrapper');

      beBoldText.style.transform = `translateY(0px)`;
      beBoldText.style.paddingTop = `8px`;

      // считаем разницу стартовых позиций текста и заголовка
      const offsetDiff =
        beBoldText.getBoundingClientRect().top +
        window.scrollY -
        (beBoldTitle.getBoundingClientRect().top + window.scrollY);

      // общий trackHeight минус эта разница
      const textTrackHeight =
        sharedTrackHeight -
        offsetDiff -
        16 -
        beBoldTitle.scrollHeight -
        beBoldText.scrollHeight / 2;

      ScrollTrigger.create({
        trigger: wrapper,
        start: `top top+=${minOffset}`,
        end: `+=${textTrackHeight}`, // подрезаем трек
        pin: true,
        pinSpacing: false,
        scrub: true,
        onUpdate: () => {
          beBoldText.style.transform = `translateY(0px)`;
        },
      });
    }, 1200);
  }
};

let beBoldSwiperWr = document.querySelectorAll('.be-bold-swiper-wr');
beBoldSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 30,
      slidesPerView: 'auto',
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
          slidesPerView: 2,
        },
      },
    });
    swiperObserver(swiper);
  }
});
